import React, { useState } from "react";
import { TemplateType } from "./ReportingTemplates";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import { proxyAPI } from "../proxyAPI";
import { toast } from "react-toastify";
import JsonCollapse from "../Builder/Components/JsonCollapse";
import contactUUID from "../Contacts/contactUUID";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX } from "@fortawesome/free-solid-svg-icons";

export default function TemplateForm({
  template: p_template,
  handleDelete,
}: {
  template: TemplateType;
  handleDelete: any;
}) {
  const [template, setTemplate] = useState(p_template);
  const [isEdited, setIsEdited] = useState(p_template.isNew);
  const [loading, setLoading] = useState(false);

  const handleChange = (field: "label" | "type", value: any) => {
    setTemplate((p) => ({ ...p, [field]: value }));
    setIsEdited(true);
  };

  const handleFieldChange = (
    fieldUUID: string,
    property: "label" | "defaultValue" | "type" | "categories" | "isMultiple",
    value: any
  ) => {
    setTemplate((p) => ({
      ...p,
      fields: p.fields.map((f) => {
        if (f.uuid === fieldUUID) {
          return {
            ...f,
            [property]: value,
            ...(property === "categories" && { defaultValue: value[0] }),
          };
        }
        return f;
      }),
    }));
    setIsEdited(true);
  };

  const handleSave = async () => {
    const data = await proxyAPI({
      prefix: "logic/reporting",
      url: "templates",
      method: "POST",
      body: template,
      setLoading,
    });
    if (data) {
      setTemplate(data);
      toast.success("Saved successfully");
      setIsEdited(false);
    }
  };

  const handleAddField = () => {
    setTemplate((p) => ({
      ...p,
      fields: [
        ...p.fields,
        {
          uuid: contactUUID(),
          label: "field",
          defaultValue: "",
          order: template.fields.length,
          type: "TEXT",
          categories: [],
        },
      ],
    }));
    setIsEdited(true);
  };

  const handleDeleteField = (order: number) => {
    setTemplate((p) => ({
      ...p,
      fields: p.fields
        .filter((f) => f.order !== order)
        .map((f, order) => ({ ...f, order })),
    }));
    setIsEdited(true);
  };

  return (
    <div key={template.uuid} className="bg-white p-3 rounded-3">
      <div className="mb-2">
        <Input
          value={[template.label]}
          onChange={(values: any[]) => handleChange("label", values[0])}
          inputHelp={undefined}
          isMulti={undefined}
          isDisabled={undefined}
          isSearchable={undefined}
          isClearable={undefined}
          options={undefined}
          onKeyUp={undefined}
          onCreateOption={undefined}
          type={undefined}
          isOptionDisabled={undefined}
          min={undefined}
          max={undefined}
          isValidNewOption={undefined}
          loadOptions={undefined}
          getValueLabels={undefined}
          autoFocus={undefined}
          label={"Template label"}
          isSummary={undefined}
          configuration={undefined}
          placeholder={undefined}
          maxLength={undefined}
          isContactSet={undefined}
          html={undefined}
          isEmail={undefined}
          dateTimeType={undefined}
          components={undefined}
          maxDate={undefined}
        />
      </div>
      <div className="mb-2">
        <Input
          value={[template.type]}
          onChange={(values: any[]) => handleChange("type", values[0])}
          inputHelp={undefined}
          isMulti={undefined}
          isDisabled={undefined}
          inputType="select"
          isSearchable={undefined}
          isClearable={undefined}
          options={[
            { value: "STACK", label: "Stack" },
            { value: "TICKETING", label: "Ticketing" },
            { value: "TOPIC", label: "Topic" },
            { value: "TICKET", label: "Ticket" },
          ]}
          onKeyUp={undefined}
          onCreateOption={undefined}
          type={undefined}
          isOptionDisabled={undefined}
          min={undefined}
          max={undefined}
          isValidNewOption={() => false}
          loadOptions={undefined}
          getValueLabels={undefined}
          autoFocus={undefined}
          label={"Template type"}
          isSummary={undefined}
          configuration={undefined}
          placeholder={undefined}
          maxLength={undefined}
          isContactSet={undefined}
          html={undefined}
          isEmail={undefined}
          dateTimeType={undefined}
          components={undefined}
          maxDate={undefined}
        />
      </div>
      <div className="py-3"></div>
      <div className="my-2 d-flex justify-content-between ">
        <h3>Fields</h3>
        <button
          type="button"
          className="btn btn-primary btn-colored"
          onClick={handleAddField}
        >
          Add field
        </button>
      </div>
      <div className="row">
        {template.fields
          .sort((a, b) => a.order - b.order)
          .map((field) => (
            <div className="col-6 my-2" key={field.uuid}>
              <div className="border border-1 rounded-3 p-3 h-100 position-relative">
                {template.fields.length > 1 && (
                  <button
                    type="button"
                    className="btn btn-outline-danger border-0 rounded-2 position-absolute top-0 end-0"
                    onClick={() => handleDeleteField(field.order)}
                  >
                    <FontAwesomeIcon icon={faX} />
                  </button>
                )}
                <div className="mb-2">
                  <Input
                    value={[field.label]}
                    onChange={(values: any[]) =>
                      handleFieldChange(field.uuid, "label", values[0])
                    }
                    inputHelp={undefined}
                    isMulti={undefined}
                    isDisabled={undefined}
                    isSearchable={undefined}
                    isClearable={undefined}
                    options={undefined}
                    onKeyUp={undefined}
                    onCreateOption={undefined}
                    type={undefined}
                    isOptionDisabled={undefined}
                    min={undefined}
                    max={undefined}
                    isValidNewOption={undefined}
                    loadOptions={undefined}
                    getValueLabels={undefined}
                    autoFocus={undefined}
                    label={"Field label"}
                    isSummary={undefined}
                    configuration={undefined}
                    placeholder={undefined}
                    maxLength={undefined}
                    isContactSet={undefined}
                    html={undefined}
                    isEmail={undefined}
                    dateTimeType={undefined}
                    components={undefined}
                    maxDate={undefined}
                  />
                </div>
                <div className="mb-2">
                  <Input
                    value={[field.type]}
                    onChange={(values: any[]) =>
                      handleFieldChange(field.uuid, "type", values[0])
                    }
                    inputHelp={undefined}
                    isMulti={undefined}
                    isDisabled={undefined}
                    inputType="select"
                    isSearchable={undefined}
                    isClearable={undefined}
                    options={[
                      { value: "TIME", label: "Time" },
                      { value: "DURATION", label: "Duration" },
                      { value: "TEXT", label: "Text" },
                      { value: "NUMBER", label: "Number" },
                      { value: "CATEGORY", label: "Category" },
                    ]}
                    onKeyUp={undefined}
                    onCreateOption={undefined}
                    type={undefined}
                    isOptionDisabled={undefined}
                    min={undefined}
                    max={undefined}
                    isValidNewOption={() => false}
                    loadOptions={undefined}
                    getValueLabels={undefined}
                    autoFocus={undefined}
                    label={"Field type"}
                    isSummary={undefined}
                    configuration={undefined}
                    placeholder={undefined}
                    maxLength={undefined}
                    isContactSet={undefined}
                    html={undefined}
                    isEmail={undefined}
                    dateTimeType={undefined}
                    components={undefined}
                    maxDate={undefined}
                  />
                </div>
                {field.type === "CATEGORY" && (
                  <div className="mb-2">
                    <Input
                      value={field.categories}
                      onChange={(values: any[]) =>
                        handleFieldChange(field.uuid, "categories", values)
                      }
                      inputHelp={undefined}
                      isMulti={true}
                      isDisabled={undefined}
                      inputType="select"
                      isSearchable={undefined}
                      isClearable={undefined}
                      options={undefined}
                      onKeyUp={undefined}
                      onCreateOption={undefined}
                      type={undefined}
                      isOptionDisabled={undefined}
                      min={undefined}
                      max={undefined}
                      isValidNewOption={(v) => !!v}
                      loadOptions={undefined}
                      getValueLabels={undefined}
                      autoFocus={undefined}
                      label={"Categories"}
                      isSummary={undefined}
                      configuration={undefined}
                      placeholder={undefined}
                      maxLength={undefined}
                      isContactSet={undefined}
                      html={undefined}
                      isEmail={undefined}
                      dateTimeType={undefined}
                      components={undefined}
                      maxDate={undefined}
                    />
                  </div>
                )}
                <div className="mb-2" key={field.type}>
                  <Input
                    value={[field.defaultValue]}
                    onChange={(values: any[]) =>
                      handleFieldChange(field.uuid, "defaultValue", values[0])
                    }
                    inputHelp={undefined}
                    isMulti={undefined}
                    isDisabled={undefined}
                    inputType={field.type === "CATEGORY" ? "select" : undefined}
                    isSearchable={undefined}
                    isClearable={true}
                    options={
                      field.type === "CATEGORY"
                        ? field.categories.map((c: string) => ({
                            value: c,
                            label: c,
                          }))
                        : null
                    }
                    onKeyUp={undefined}
                    onCreateOption={undefined}
                    type={undefined}
                    isOptionDisabled={undefined}
                    min={undefined}
                    max={undefined}
                    isValidNewOption={() => field.type !== "CATEGORY"}
                    loadOptions={undefined}
                    getValueLabels={undefined}
                    autoFocus={undefined}
                    label={"Default value"}
                    isSummary={undefined}
                    configuration={undefined}
                    placeholder={undefined}
                    maxLength={undefined}
                    isContactSet={undefined}
                    html={undefined}
                    isEmail={undefined}
                    dateTimeType={undefined}
                    components={undefined}
                    maxDate={undefined}
                  />
                  {(field.defaultValue === "" || !field.defaultValue) && (
                    <div className="text-danger">
                      If you don't enter a default value, the field will be
                      required
                    </div>
                  )}
                </div>
                <div className="mb-2">
                  <Input
                    value={[!!field.isMultiple]}
                    onChange={(values: any[]) =>
                      handleFieldChange(field.uuid, "isMultiple", values[0])
                    }
                    options={[
                      { value: false, label: "No" },
                      { value: true, label: "Yes" },
                    ]}
                    inputType="radio"
                    radioName={field.uuid + "isMultiple"}
                    label={"Is Multiple"}
                  />
                  {(field.defaultValue === "" || !field.defaultValue) && (
                    <div className="text-danger">
                      If you don't enter a default value, the field will be
                      required
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
      </div>
      <div className="mb-2">
        <div className="text-end">
          <button
            type="button"
            className="btn btn-dark mx-2"
            style={{ width: 150 }}
            onClick={() => handleDelete(template)}
          >
            Delete template
          </button>
          {isEdited && (
            <button
              type="button"
              className="btn btn-secondary mx-2"
              onClick={handleSave}
              style={{ width: 100 }}
              disabled={!isEdited}
            >
              Save
            </button>
          )}
        </div>
      </div>
      <JsonCollapse json={template} />
    </div>
  );
}
